import {
  faAddressBook,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircleInfo,
  faHome,
  faKitMedical,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "../StyleSheets/Navbar.css";
import AILogo from "../Utils/Images/Logo Images/AliveAI Logo.png";
import { useAuth } from "./Routes/AuthContext";
import { useAuthNavigation } from "./Utils/useAuthNavigation";
import { useMediaQuery } from "@mui/material";

// navfeatureArr used in web and mobile component.
export const navbarFeatureArr = ({ StaticData }) => {
  const { Sub_MenuData_Text } = StaticData.Dashboard_Data.MenuData_Text;

  return [
    Sub_MenuData_Text.Sub_MenuData_Text_1,
    Sub_MenuData_Text.Sub_MenuData_Text_2,
    Sub_MenuData_Text.Sub_MenuData_Text_3,
    Sub_MenuData_Text.Sub_MenuData_Text_4,
    Sub_MenuData_Text.Sub_MenuData_Text_5,
    Sub_MenuData_Text.Sub_MenuData_Text_6,
    Sub_MenuData_Text.Sub_MenuData_Text_7,
    Sub_MenuData_Text.Sub_MenuData_Text_8,
    Sub_MenuData_Text.Sub_MenuData_Text_9,
    Sub_MenuData_Text.Sub_MenuData_Text_10,
    Sub_MenuData_Text.Sub_MenuData_Text_11,
  ];
};

// Logo Component
const Logo = () => {
  return <img src={AILogo} alt="" className="logo-container" />;
};

// Hamburger Button
const HamburgerButton = () => (
  <>
    <div className="line-lg"></div>
    <div className="line-md"></div>
    <div className="line-lg"></div>
  </>
);

//   CustomButton used in Web and Mobile Component
const CustomButton = ({
  path,
  label,
  matches_991,
  setShowOffcanvas = () => {},
  setShowDropdown = () => {},
}) => (
  <Button
    as={Link}
    to={path}
    className={matches_991 ? "mx-2" : "w-100 me-2"}
    variant="outline-info"
    size={matches_991 ? "md" : "sm"}
    onClick={() => {
      setShowOffcanvas(false);
      setShowDropdown(false);
    }}
  >
    {label}
  </Button>
);

// WebNavbar Component
const WebNavbar = ({ Header, matches_991, featureArray }) => {
  const {
    Header_Link_1,
    Header_Link_2,
    Header_Link_3,
    Header_Link_4,
    Header_Login_Button,
    Header_SignUp_Button,
    Header_Dashboard_Button,
    Header_Logout_Button,
    Header_Login_Link,
    Header_Signup_Link,
    Header_About_Link,
    Header_Contact_Link,
    Header_Dashboard_Link,
    Header_Feature_Link,
  } = Header;

  const featureRoutes = {
    "Diabetes Analysis": "/dashboard/health-analysis/diabetes-analysis",
    "Asthma Analysis": "/dashboard/health-analysis/asthma-analysis",
    "Cardiovascular Analysis": "/dashboard/health-analysis/cardiovascular-analysis",
    "Heart and Strokes Analysis": "/dashboard/health-analysis/heartstrokes-analysis",
    "Liver Condition Analysis": "/dashboard/health-analysis/livercondition-analysis",
    "Alzheimer Disease": "/dashboard/health-analysis/alzheimer-analysis",
    "Cancer Disease": "/dashboard/health-analysis/cancer-analysis",
    "Chronic Kidney Disease": "/dashboard/health-analysis/chronic-kidney-analysis",
    "Hypertension Disease": "/dashboard/health-analysis/hypertension-analysis",
    "Osteoporosis Disease": "/dashboard/health-analysis/osteoporosis-analysis",
    "Pancreatic Disease": "/dashboard/health-analysis/pancreatic-analysis",
  };

  const { isAuthenticated, logout } = useAuth();
  const { navigateWithAuth } = useAuthNavigation();
  const location = useLocation();

  const [activeMenu, setActiveMenu] = useState(
    localStorage.getItem("activeMenu") || location.pathname
  );

  const [activeDropdownItem, setActiveDropdownItem] = useState(
    JSON.parse(localStorage.getItem("activeDropdownItem")) || null
  );

  useEffect(() => {
    setActiveMenu(location.pathname);
    localStorage.setItem("activeMenu", location.pathname);
  }, [location.pathname]);

  const handleNavClick = (path) => {
    setActiveMenu(path);
    localStorage.setItem("activeMenu", path);
    setActiveDropdownItem(null);
    localStorage.removeItem("activeDropdownItem");
  };

  return (
    <>
      <Nav>
        <Nav.Link
          as={Link}
          to="/"
          className={`me-4 ${activeMenu === "/" ? "active-nav-item" : ""}`}
          onClick={() => handleNavClick("/")}>
          <FontAwesomeIcon icon={faHome} className="me-2" />
          {Header_Link_1}
        </Nav.Link>

        <Nav.Link
          as={Link}
          to={`/${Header_About_Link}`}
          className={`me-4 ${
            activeMenu === `/${Header_About_Link}` ? "active-nav-item" : ""
          }`}
          onClick={() => handleNavClick(`/${Header_About_Link}`)}>
          <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
          {Header_Link_2}
        </Nav.Link>

        <Nav.Link
          as={Link}
          to={`/${Header_Contact_Link}`}
          className={`me-4 ${
            activeMenu === `/${Header_Contact_Link}` ? "active-nav-item" : ""
          }`}
          onClick={() => handleNavClick(`/${Header_Contact_Link}`)}>
          <FontAwesomeIcon icon={faAddressBook} className="me-2" />
          {Header_Link_3}
        </Nav.Link>

        <NavDropdown
          title={
            <span
              className={` ${
                activeMenu === `/${Header_Feature_Link}`
                  ? "active-nav-item"
                  : ""
              }`}>
              <span className="me-2">
                <FontAwesomeIcon icon={faKitMedical} />
              </span>
              {Header_Link_4}
            </span>
          }
          id="feature-dropdown">
          {featureArray.map((analysis, index) => {
            const route = featureRoutes[analysis] || `/${Header_Feature_Link}`;

            return (
              <NavDropdown.Item
                key={index}
                className="nav-dropdown-item underline-expand d-flex align-items-center"
                onClick={() => navigateWithAuth(route)}>
                <FontAwesomeIcon
                  className="fa-xs"
                  icon={faChevronRight}
                  style={{ paddingRight: "5px", color: "#3dd5f3" }}
                />
                <span style={{ fontSize: "0.8rem" }}>{analysis}</span>
              </NavDropdown.Item>
            );
          })}
        </NavDropdown>
      </Nav>

      <Nav>
        {isAuthenticated ? (
          <>
            <Button
              as={Link}
              to={`/${Header_Dashboard_Link}`}
              className={`mx-2 ${
                activeMenu === `/${Header_Dashboard_Link}`
                  ? "active-nav-item"
                  : ""
              }`}
              variant="outline-info"
              size="md">
              {Header_Dashboard_Button}
            </Button>
            <Button
              onClick={logout}
              className="mx-2"
              variant="outline-info"
              size="md">
              {Header_Logout_Button}
            </Button>
          </>
        ) : (
          <>
            <CustomButton
              matches_991={matches_991}
              path={`/${Header_Login_Link}`}
              label={Header_Login_Button}
            />
            <CustomButton
              matches_991={matches_991}
              path={`/${Header_Signup_Link}`}
              label={Header_SignUp_Button}
            />
          </>
        )}
      </Nav>
    </>
  );
};

// MobileNavbar Component
const MobileNavbar = ({ Header, featureArray }) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const { navigateWithAuth } = useAuthNavigation();

  const [showDropdown, setShowDropdown] = useState(false);
  const handleLinkClick = () => {
    setShowOffcanvas(false);
    setShowDropdown(false);
  };

  const {
    Header_Link_1,
    Header_Link_2,
    Header_Link_3,
    Header_Link_4,
    Header_Login_Button,
    Header_SignUp_Button,
    Header_Dashboard_Button,
    Header_Logout_Button,
    Header_Login_Link,
    Header_Signup_Link,
    Header_About_Link,
    Header_Contact_Link,
    Header_Dashboard_Link,
    Header_Feature_Link,
  } = Header;

  const featureRoutes = {
    "Diabetes Analysis": "/dashboard/health-analysis/diabetes-analysis",
    "Asthma Analysis": "/dashboard/health-analysis/asthma-analysis",
    "Cardiovascular Analysis": "/dashboard/health-analysis/cardiovascular-analysis",
    "Heart and Strokes Analysis": "/dashboard/health-analysis/heartstrokes-analysis",
    "Liver Condition Analysis": "/dashboard/health-analysis/livercondition-analysis",
    "Alzheimer Disease": "/dashboard/health-analysis/alzheimer-analysis",
    "Cancer Disease": "/dashboard/health-analysis/cancer-analysis",
    "Chronic Kidney Disease": "/dashboard/health-analysis/chronic-kidney-analysis",
    "Hypertension Disease": "/dashboard/health-analysis/hypertension-analysis",
    "Osteoporosis Disease": "/dashboard/health-analysis/osteoporosis-analysis",
    "Pancreatic Disease": "/dashboard/health-analysis/pancreatic-analysis",
  };

  return (
    <>
      <Navbar expand="lg" bg="dark" variant="dark">
        <Container>
          <button
            className="hamburger"
            onClick={() => setShowOffcanvas((prevState) => !prevState)}>
            <HamburgerButton />
          </button>
        </Container>
      </Navbar>

      <Offcanvas
        show={showOffcanvas}
        onHide={() => setShowOffcanvas(false)}
        placement="end"
        style={{ backgroundColor: "#212529", color: "white" }}>
        <Offcanvas.Header closeButton onClick={() => setShowDropdown(false)} />

        <Offcanvas.Body>
          {isAuthenticated ? (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Button
                as={Link}
                to={`/${Header_Dashboard_Link}`}
                className="w-50 me-2"
                variant="outline-info"
                size="sm"
                onClick={handleLinkClick}>
                {Header_Dashboard_Button}
              </Button>
              <Button
                onClick={logout}
                className="w-50 me-2"
                variant="outline-info"
                size="sm">
                {Header_Logout_Button}
              </Button>
            </div>
          ) : (
            <Container>
              <div className="d-flex gap-3">
                <CustomButton
                  path={`/${Header_Login_Link}`}
                  label={Header_Login_Button}
                  setShowOffcanvas={setShowOffcanvas}
                  setShowDropdown={setShowDropdown}
                />
                <CustomButton
                  path={`/${Header_Signup_Link}`}
                  label={Header_SignUp_Button}
                  setShowOffcanvas={setShowOffcanvas}
                  setShowDropdown={setShowDropdown}
                />
              </div>
            </Container>
          )}
          <Nav className="flex-column ms-3 mt-2">
            <Nav.Link
              as={Link}
              to="/"
              className="me-4 nav-bar"
              onClick={handleLinkClick}>
              <FontAwesomeIcon icon={faHome} className="me-2" />
              {Header_Link_1}
            </Nav.Link>

            <Nav.Link
              as={Link}
              to={`/${Header_About_Link}`}
              className="me-4"
              onClick={handleLinkClick}>
              <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
              {Header_Link_2}
            </Nav.Link>

            <Nav.Link
              as={Link}
              to={`/${Header_Contact_Link}`}
              className="me-4"
              onClick={handleLinkClick}>
              <FontAwesomeIcon icon={faAddressBook} className="me-2" />
              {Header_Link_3}
            </Nav.Link>

            {/* ✅ UPDATED DROPDOWN TRIGGER BUTTON */}
            <button
              type="button"
              className="me-4 nav-link"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowDropdown((prev) => !prev);
              }}
              style={{
                cursor: "pointer",
                background: "none",
                border: "none",
                color: "inherit",
                padding: 0,
              }}>
              <FontAwesomeIcon icon={faKitMedical} className="me-2" />
              {Header_Link_4}{" "}
              <FontAwesomeIcon
                icon={showDropdown ? faChevronDown : faChevronUp}
              />
            </button>

            {showDropdown && (
              <Nav className="flex-column ms-3 mt-2">
                {featureArray.map((analysis, index) => {
                  const route =
                    featureRoutes[analysis] || `/${Header_Feature_Link}`;

                  return (
                    <Nav.Link
                      key={index}
                      className="me-4"
                      onClick={() => {
                        handleLinkClick();
                        navigateWithAuth(route);
                      }}>
                      <FontAwesomeIcon
                        className="fa-xs"
                        icon={faChevronRight}
                        style={{ paddingRight: "5px", color: "#3dd5f3" }}
                      />
                      {analysis}
                    </Nav.Link>
                  );
                })}
              </Nav>
            )}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

const Header = ({ StaticData }) => {
  const matches_991 = useMediaQuery(`(min-width:991px)`);
  const { Header } = StaticData;
  const featureArray = navbarFeatureArr({ StaticData });

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        bg="dark"
        data-bs-theme="dark"
        style={{ minWidth: 250 }}
        className="shadow-lg fixed-top">
        <Container>
          <Navbar.Brand>
            <Nav.Link as={Link} to="/">
              <Logo />
            </Nav.Link>
          </Navbar.Brand>
          {matches_991 ? (
            <WebNavbar
              Header={Header}
              matches_991={matches_991}
              featureArray={featureArray}
            />
          ) : (
            <MobileNavbar Header={Header} featureArray={featureArray} />
          )}
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
